// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"ScrollCard__outerBox__HShyI","tabLine":"ScrollCard__tabLine__6nZix","eachCardBox":"ScrollCard__eachCardBox__kaLYB"};